// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-SkinTrack-Detail-Mark__mark--ju3Wp{width:30px;height:30px;border-radius:20px;position:absolute;cursor:move}.src-SkinTrack-Detail-Mark__mark--ju3Wp.src-SkinTrack-Detail-Mark__locked--VUIxU{cursor:default;user-drag:none;user-select:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mark": "src-SkinTrack-Detail-Mark__mark--ju3Wp",
	"locked": "src-SkinTrack-Detail-Mark__locked--VUIxU"
};
export default ___CSS_LOADER_EXPORT___;
